import React from "react";
import { Button, Input, Modal, Select } from "antd";
import { useSelector } from "react-redux";
import { checkValidEngNumbers, onChangeProvince } from "../../../core/utils";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";

const AddDriver = (props) => {
  const {
    isAddDriverModalOpen,
    setIsAddDriverModalOpen,
    driverState,
    handleAddDriverStateChange,
    cities,
    setCities,
    onAddDriver,
  } = props;
  const store = useSelector((state) => state.Store);

  const { Option } = Select;
  return (
    <>
      <div className="">
        <Button
          onClick={() => setIsAddDriverModalOpen(true)}
          className="button-primary w-220px  flex flex-items-center flex-content-center"
        >
          <li className="fas fa-plus pr-2"></li>
          <span>Add Driver</span>
        </Button>
      </div>
      <Modal
        open={isAddDriverModalOpen}
        onCancel={() => {
          setIsAddDriverModalOpen(false);
          handleAddDriverStateChange({
            province_id: null,
            city_id: null,
            first_name: "",
            last_name: "",
            national_id: "",
            phone_number: "",
          });
        }}
        footer={null}
        closable={true}
        title="Add Driver"
        bodyStyle={{
          paddingBottom: 8,
          paddingLeft: 0,
          paddingRight: 0,
        }}
        closeIcon={
          <CloseModalButton
            isCloseIcon
            close={() => setIsAddDriverModalOpen(false)}
          />
        }
      >
        <div className="flex-row flex-content-space-between flex-wrap py-10 px-20">
          <FormWrapper>
            <Select
              className="border-black-8 my-5 "
              showSearch
              placeholder={"Province"}
              value={driverState.province_id}
              onChange={(value) =>
                onChangeProvince(
                  value,
                  () =>
                    handleAddDriverStateChange({
                      province_id: value,
                      city_id: null,
                    }),
                  setCities
                )
              }
            >
              <Option value={null} name="All Provinces">
                All Provinces
              </Option>
              {store.provinces.map((province) => {
                return (
                  <Option value={province.id} key={province.province_id}>
                    {province.name}
                  </Option>
                );
              })}
            </Select>
            <Select
              className="border-black-8 my-5"
              showSearch
              placeholder={"City"}
              value={driverState.city_id}
              onChange={(value) =>
                handleAddDriverStateChange({ city_id: value })
              }
              disabled={!driverState.province_id}
            >
              <Option value={null} name="All Cities">
                All Cities
              </Option>
              {cities.map((city) => {
                return (
                  <Option value={city.id} key={city.id}>
                    {city.name}
                  </Option>
                );
              })}
            </Select>
            <Input
              className="input-black border-black-8 my-5"
              placeholder="First Name"
              value={driverState.first_name}
              onChange={(e) =>
                handleAddDriverStateChange({ first_name: e.target.value })
              }
            />
            <Input
              className="input-black border-black-8 my-5 "
              placeholder="Last Name"
              value={driverState.last_name}
              onChange={(e) =>
                handleAddDriverStateChange({ last_name: e.target.value })
              }
            />
            <Input
              className="input-black border-black-8 my-5"
              placeholder="National ID"
              value={driverState.national_id}
              onChange={(e) =>
                handleAddDriverStateChange({ national_id: e.target.value })
              }
              onKeyDown={checkValidEngNumbers}
              maxLength={10}
            />

            <Input
              className="input-black border-black-8 my-5 "
              placeholder="Mobile Number"
              value={driverState.phone_number}
              onChange={(e) =>
                handleAddDriverStateChange({ phone_number: e.target.value })
              }
              onKeyDown={checkValidEngNumbers}
              maxLength={11}
            />
            <div className="w-100"></div>

            <Button className="button-primary mt-5" onClick={onAddDriver}>
              Add Driver
            </Button>
          </FormWrapper>
        </div>
      </Modal>
    </>
  );
};

export default AddDriver;
